// 公開設定 — 可以 commit
// 環境變數透過 Vite 的 import.meta.env 讀（VITE_ 開頭才會曝露給前端）

// e118-class-activities worker 已上線（共用 e118-field-study 的 R2 bucket，prefix 隔開）
const DEFAULT_PUBLIC_BASE = "https://pub-26cb42e42bdd4fb3af0b050237092ee7.r2.dev";
const DEFAULT_WORKER_BASE = "https://e118-class-activities-worker.chengchieh-huang.workers.dev";

export const R2_PUBLIC_BASE =
  import.meta.env.VITE_R2_PUBLIC_BASE || DEFAULT_PUBLIC_BASE;

export const WORKER_BASE =
  import.meta.env.VITE_WORKER_BASE || DEFAULT_WORKER_BASE;

// 沒接 R2 manifest 時，這個就是個空 URL，fetchManifest 會 fail-safe 回空物件
export const MANIFEST_URL = R2_PUBLIC_BASE ? `${R2_PUBLIC_BASE}/activities-manifest.json` : "";

// 是否啟用 R2 / Worker 功能（影響 UI 是否顯示「上傳照片」按鈕等）
export const R2_ENABLED = Boolean(R2_PUBLIC_BASE && WORKER_BASE);
